import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { AppDataService, ConfigService, XpressUserService } from 'app/services';
import { XpressUserRoleEnum } from 'app/models';
import { CustomWindow } from 'app/@types';
import { MenuComponent } from 'app/layout';
import { AppComponent } from 'app/app.component';
import { StylesStatus } from 'app/models/users/StylesStatus';
import { XpressUserProfile } from 'app/models/users/XpressUserProfile';
import { Pipe, PipeTransform } from '@angular/core';

declare let window: CustomWindow;

@Component({
    selector: 'xpress-topbar',
    templateUrl: './xpress-topbar.component.html',
    styleUrls: ['./xpress-topbar.component.scss'],
    providers: [MessageService]
})
export class XpressTopbarComponent implements OnInit{

    @Output()
    public isProfileVisible = new EventEmitter<boolean>();

    @Input() set _showMyProfile(value: boolean) {
        this.showMyProfile = value;
    }

    public xpressUserRoleEnum = XpressUserRoleEnum;

    items: MenuItem[] = [];

    public showPartnerProfilePopup: boolean = false;
    public showPartnerAccessPopup: boolean = false;

    public profileXpressUserRoleId: XpressUserRoleEnum = XpressUserRoleEnum.None;
    public profileUserId: number = 0;

    @ViewChild(MenuComponent)
    public menuComponent!: MenuComponent;

    public profile: XpressUserProfile = new XpressUserProfile();
    public initialProfile: XpressUserProfile = new XpressUserProfile();
    public tier = TierEnum.Bronze; //TODO remove later
    public tiersEnabled = false; //TODO remove later
    public showMyProfile: boolean = false;

    constructor(
        public appData: AppDataService,
        public app: AppComponent,
        public configService: ConfigService,
        private messageService: MessageService,
        private xpressUserService: XpressUserService,
        private cdr: ChangeDetectorRef) {
        this.refreshAuthData();
        this.onPartnerProfilePopupHide = this.onPartnerProfilePopupHide.bind(this);
        this.onPartnerProfilePopupSave = this.onPartnerProfilePopupSave.bind(this);
        this.onPartnerAccessPopupHide = this.onPartnerAccessPopupHide.bind(this);
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.getUserProfile();
        }, 1000);
    }

    isOperator() {
        return +this.appData.authData.roleId === XpressUserRoleEnum.Operator;
    }

    isMerchant() {
        return +this.appData.authData.roleId === XpressUserRoleEnum.Merchant;
    }

    public getTierStyle(tier: string): StylesStatus {
        let backgroundColor: string = '';
        let textColor: string = '';
        switch (tier) {
            case TierEnum.Bronze: textColor = '#B07504'; break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    public getUserProfile() {
        const dto = {
            XpressUserId: +this.appData.authData.UserId,
        };
        this.xpressUserService.getUserProfile(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                if (data.BirthDate) {
                    data.BirthDate = new Date(data.BirthDate);
                }
                this.profile = data;
                this.initialProfile = JSON.parse(JSON.stringify(this.profile));
                this.fillExistingFilesData();
                this.xpressUserService.updateProfile(this.initialProfile);
            });

    }

    private fillExistingFilesData() {
        if (this.profile.GovIdUrls) {
            this.profile.GovIdData = [];
            this.initialProfile.GovIdData = [];
            for (let i=0; i<this.profile.GovIdUrls.length; i++) {
                this.profile.GovIdData.push(new File([], (i+1)+''));
                this.initialProfile.GovIdData.push(new File([], (i+1)+''));
            }
        }
        if (this.profile.DTIorSECCertifUrls) {
            this.profile.DTIorSECCertifData = [];
            this.initialProfile.DTIorSECCertifData = [];
            for (let i=0; i<this.profile.DTIorSECCertifUrls.length; i++) {
                this.profile.DTIorSECCertifData.push(new File([], (i+1)+''));
                this.initialProfile.DTIorSECCertifData.push(new File([], (i+1)+''));
            }
        }
        if (this.profile.BIRCertifUrls) {
            this.profile.BIRCertifData = [];
            this.initialProfile.BIRCertifData = [];
            for (let i=0; i<this.profile.BIRCertifUrls.length; i++) {
                this.profile.BIRCertifData.push(new File([], (i+1)+''));
                this.initialProfile.BIRCertifData.push(new File([], (i+1)+''));
            }
        }
        if (this.profile.LTFRBCertifUrls) {
            this.profile.LTFRBCertifData = [];
            this.initialProfile.LTFRBCertifData = [];
            for (let i=0; i<this.profile.LTFRBCertifUrls.length; i++) {
                this.profile.LTFRBCertifData.push(new File([], (i+1)+''));
                this.initialProfile.LTFRBCertifData.push(new File([], (i+1)+''));
            }
        }
        if (this.profile.BusinessPermitUrls) {
            this.profile.BusinessPermitData = [];
            this.initialProfile.BusinessPermitData = [];
            for (let i=0; i<this.profile.BusinessPermitUrls.length; i++) {
                this.profile.BusinessPermitData.push(new File([], (i+1)+''));
                this.initialProfile.BusinessPermitData.push(new File([], (i+1)+''));
            }
        }
    }

    public copyCode() {
        navigator.clipboard.writeText(this.profile.OperatorCode+'').then(() => {
            this.messageService.add({severity: 'info', summary: 'Copied!', detail: 'Operator\'s Code copied to clipboard.'});
        }).catch(() => {
            this.messageService.add({severity: 'error', summary: 'Error', detail: 'Unable to copy code.'});
        });
    }

    onHelpCenterClick() {
        window.open('https://www.xpress.ph/help','_blank');
    }

    public onMyProfileHide(): void {
        this.showMyProfile = false;
    }

    public onProfileUpdate(profile: any) {
        this.profile = profile;
        // this.initialProfile = JSON.parse(JSON.stringify(this.profile));
    }

    public onProfileClick(): void {
        this.profileUserId = +this.appData.authData.UserId;
        if (this.appData.xpressUserRoleId === XpressUserRoleEnum.Merchant) {
            this.profileXpressUserRoleId = XpressUserRoleEnum.Merchant;
            this.showPartnerProfilePopup = true;
        } else {
            this.showMyProfile = true;
        }
        this.isProfileVisible.emit(true);
    }

    public onPartnerProfilePopupHide(): void {
        this.showPartnerProfilePopup = false;
    }

    // On Update click in PartnerProfilePopup
    public onPartnerProfilePopupSave(): void {
        this.showPartnerProfilePopup = false;

        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully updated' });

        // Refresh AuthData
        this.refreshAuthData();
    }

    // Refresh AuthData
    private refreshAuthData(): void {
        this.xpressUserService.getAuthData(this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                this.appData.authData.FirstName = data.FirstName;
                this.appData.authData.LastName = data.LastName;
                this.appData.authData.Email = data.Email;
                this.appData.authData.ImageUrl = data.ImageUrl;
                this.appData.authData.roleId = data.roleId;
                if (this.appData.authData.roleId === XpressUserRoleEnum.Merchant+'' || this.appData.authData.roleId === XpressUserRoleEnum.TourOperator+''){
                    this.profileXpressUserRoleId = XpressUserRoleEnum.Merchant;
                }
                else if(this.appData.authData.roleId === XpressUserRoleEnum.Admin.toString()){
                    this.profileXpressUserRoleId = XpressUserRoleEnum.Admin;
                }
				else if(this.appData.authData.roleId === XpressUserRoleEnum.Operator.toString()){
                    this.profileXpressUserRoleId = XpressUserRoleEnum.Operator;
                }
                this.cdr.detectChanges();
            });
    }

    public onProvideAccessClick(): void {
        if (this.appData.xpressUserRoleId === XpressUserRoleEnum.Merchant) {
            this.showPartnerAccessPopup = true;
        }
    }

    public onPartnerAccessPopupHide(): void {
        this.showPartnerAccessPopup = false;
    }

    public logout(): boolean {
        this.appData.logout();
        return false;
    }

    public hideProfile(event: boolean): void{
        this.isProfileVisible.emit(event);
        this.showMyProfile = false;
    }

    protected readonly XpressUserRoleEnum = XpressUserRoleEnum;
}

export enum TierEnum {
    Bronze = 'Bronze Tier',
    Silver = 'Silver Tier',
    Gold = 'Gold Tier',
}

@Pipe({ name: 'isMerchant' })
export class IsMerchantPipe implements PipeTransform {
  transform(roleId: XpressUserRoleEnum): boolean {
    return roleId === XpressUserRoleEnum.Merchant || roleId === XpressUserRoleEnum.TourOperator;
  }
}

